import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, FormArray, AbstractControl, ReactiveFormsModule } from "@angular/forms";
import { CustomFieldType } from "@enums/customfields/CustomFieldType";
import { CustomFieldInfoModel } from "@models/customfields/CustomFieldInfoModel";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "./i18n/scope";
import { NgSelectModule } from "@ng-select/ng-select";
import { CerrixTextfieldComponent } from "@app/shared/components/cerrix-textinput/cerrix-textfield/cerrix-textfield.component";
import { CerrixTextAreaComponent } from "@app/shared/components/cerrix-textinput/cerrix-textarea/cerrix-textarea.component";
import { DateInputComponent } from "@app/shared/components/date-input/date-input.component";
import { InputTooltipDirective } from "@app/shared/directives/input-tooltip.directive";

@Component({
    selector: "cerrix-custom-fields-editor",
    templateUrl: "./cerrix-custom-fields-editor.component.html",
    styleUrls: ["./cerrix-custom-fields-editor.component.scss"],
    imports: [
        ReactiveFormsModule,
        TranslatePipe,
        NgSelectModule,
        CerrixTextfieldComponent,
        CerrixTextAreaComponent,
        DateInputComponent,
        InputTooltipDirective,
    ],
    viewProviders: [provideTranslationScope(scope)],
})
export class CerrixCustomFieldsEditorComponent implements OnInit {
    @Input() parentForm: FormGroup;
    @Input() customFieldData: CustomFieldInfoModel;
    @Input() singleColumn: boolean = true;
    @Input() emptyMessage: string;

    // CustomFields fields
    CustomFieldType = CustomFieldType;
    columns: number = 12;

    customFieldControlInfos: CustomFieldControlInfo[] = [];

    public ngOnInit() {
        const allControls = this.getCustomFieldControls();

        this.columns = this.singleColumn ? 12 : 6;

        allControls.forEach((control) => {
            const id = this.getCustomFieldIdValue(control);
            const data = this.getCustomFieldData(id);
            const newControl = <CustomFieldControlInfo>{
                id: id,
                data: data,
                control: control,
            };
            this.customFieldControlInfos.push(newControl);
        });
    }

    // Page helper functions
    getCustomFieldControls(): AbstractControl[] {
        return (this.parentForm.get("customFields") as FormArray).controls;
    }

    getCustomFieldIdValue(customField: AbstractControl): number {
        return customField.get("customFieldId").value;
    }

    getCustomFieldData(customFieldId: number): CustomFieldInfoModel {
        return this.customFieldData[customFieldId];
    }
}

export class CustomFieldControlInfo {
    id: number;
    data: CustomFieldInfoModel;
    control: AbstractControl;
}
